// extracted by mini-css-extract-plugin
module.exports = {"media":"Media_media___8kaZ"};